<template>
        <b-input-group v-outSideClick="hideResults" :prepend="name" class="position-relative flex-nowrap">
            <b-list-group v-if="showResults" class="position-absolute autocomplete-result-position w-100 list-group-flush border rounded">
                <template v-if="results.length">
                    <b-list-group-item
                            class="py-1 px-2 cursor-pointer"
                            action
                            v-for="item in results"
                            :key="item.value"
                            @click.prevent="choose(item)"
                    >
                        <b-row>
                            <b-col>
                                {{ item.preview.address + ' , ' + item.preview.city + ' , ' + item.preview.pc}}
                            </b-col>
                        </b-row>
                    </b-list-group-item>

                </template>
            </b-list-group>
            <div class="d-flex flex-row flex-grow-1 p-0 position-relative">
                <b-form-input
                    v-model="addressText"
                    @focus="inputFocus"
                    @update="searchResult"
                    autocomplete="off"
                    :disabled="selected"
                    :name="name"
                    placeholder="Required"
                    class="myFeild"
                />

                <font-awesome-icon
                    v-if="selected"
                    icon="times"
                    class="text-danger clear-btn clear-vertical-center cursor-pointer position-absolute"
                    @click="clear"
                />
            </div>
        </b-input-group>
</template>

<script>
    import {getGeoCode, searchAddress} from "../../lib/searchAddress";

    export default {
        name: "autocomplete",
        props: {
            value: {required: true},
            name: {required: true},
        },
        data () {
            return {
                addressText: null,
                selected: false,
                results: [],
                showResults: false
            }
        },
        computed: {
            addressModel: {
                get () {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('update:address', val)
                }
            }
        },
        mounted () {
          if (this.value) {
              this.addressText = this.value.preview.address + ' , ' + this.value.preview.city + ' , ' + this.value.preview.pc
              this.selected = true
          }
        },
        methods: {
            change () {
                this.addressModel = ''
            },
            choose (item) {
                this.selected = true
                this.addressModel = item
                this.addressText = item.preview.address + ' , ' + item.preview.city + ' , ' + item.preview.pc
                this.showResults = false
                this.getGeoCode(this.addressText)
            },
            getGeoCode (address) {
                getGeoCode(address).then(res => {
                    const coordinate = res.geometry
                    this.getDeliveryFee(coordinate.location)
                }).catch(err => {
                    console.log(err)
                })
            },
            getDeliveryFee (coordinate) {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    DistanceType: 'MI',
                    LAT: coordinate.lat,
                    LONG: coordinate.lng
                }
                this.$emit('supportAddress', 'empty')
                this.$api.getRestaurant.GetRestaurantDeliveryFee(model).then(res => {
                    if (res.success) {
                        let result = res.deliveryFeeInfo
                        if (result[1] == -1) {
                            this.$emit('supportAddress', 'noSupport')
                        } else {
                            this.$emit('supportAddress', 'support')
                            this.$emit('update:deliveryFeeType', result[1] + result[0])
                        }
                    }
                }).catch(() => {

                })
            },
            inputFocus () {
                this.searchResult(this.addressText)
            },
            searchResult (keyword) {
                if (keyword !== null && keyword !== '') {
                    searchAddress(keyword).then(res => {
                        this.results = res.data
                        this.showResults = true
                    }).catch(err => {
                        this.results = []
                        this.showResults = false
                        this.$showError(err)
                    })
                } else {
                    console.log('no val')
                }
            },
            hideResults() {
                this.showResults = false
            },
            clear () {
                this.showResults = false
                this.selected = false
                this.addressModel = null
                this.addressText = null
            }

        }
    }
</script>

<style scoped>
    .autocomplete-result-position{
        top: 100%;
        right: 0;
        z-index: 1000;
        max-height: 200px;
        overflow-y: auto !important;
        overflow-x: hidden;
    }
    .clear-btn, .status-menu{
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>
